import { Icon } from '@livable/saas-react-components';
import { Button, IconButton, Typography } from '@mui/material';
import React from 'react';
// import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import ComparisonTable from './comparisonTable';
import useStyles from './styles';
const Comparison = _ref => {
  let comparison = _ref.comparison,
    setShowComparisonModal = _ref.setShowComparisonModal;
  const classes = useStyles();
  // const { t } = useTranslation();
  const page = 'Apply Billing';
  const handleCloseComparison = source => {
    track(events.modalClosed('Comparison'), {
      page,
      source
    });
    setShowComparisonModal(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBoxTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Compare to previous cycles"), /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => handleCloseComparison('Close Icon')
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), comparison !== null && comparison !== void 0 && comparison.isBillIncreasedBy20Percent ? /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBoxCaption
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBoxWarning
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "warning"
  }), /*#__PURE__*/React.createElement("span", null, "Your allocation amount has increased by more than 20% since last time."))) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBoxTable
  }, /*#__PURE__*/React.createElement(ComparisonTable, {
    comparison: comparison
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.comparisonBoxFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleCloseComparison('Done'),
    size: "small",
    variant: "text",
    'custom-attribute': '610-new-billing-module'
  }, "Done")));
};
export default Comparison;